// Kept apart from routes.tsx on purpose: components build links from here, and routes.tsx imports the pages,
// so folding the two together would import the pages from inside the pages.
export const capacityPaths = {
    list: (accountSlug: string) => `/account/${accountSlug}/products/inventory/home`,
    create: (accountSlug: string) => `/account/${accountSlug}/products/inventory/item/new`,
    item: (accountSlug: string, capacityId: string) => `/account/${accountSlug}/products/inventory/item/${capacityId}`,
    exception: (accountSlug: string, capacityId: string, ruleId: string) =>
        `/account/${accountSlug}/products/inventory/rule/${ruleId}/item/${capacityId}`,
    newException: (accountSlug: string, capacityId: string) =>
        `/account/${accountSlug}/products/inventory/rule/new/item/${capacityId}`,
    capacityReport: (accountSlug: string) => `/account/${accountSlug}/orders/capacity_report/`,
    product: (accountSlug: string, productId: string) => `/account/${accountSlug}/products/crud/${productId}`,
    category: (accountSlug: string, categoryId: string) =>
        `/account/${accountSlug}/products/crud/productList/${categoryId}`,
    optionItem: (accountSlug: string, groupUuid: string, itemId: string) =>
        `/account/${accountSlug}/products/option_groups/option_item/${groupUuid}/${itemId}`,
    timeSlots: (accountSlug: string) => `/account/${accountSlug}/products/time_slots/home`,
    timeSlotGroup: (accountSlug: string, groupId: string) =>
        `/account/${accountSlug}/products/time_slots/edit/${groupId}`,
}

export const CAPACITY_ROUTE_PREFIX = '/account/:accountSlug/products/inventory'
export const CAPACITY_ROUTES = {
    list: `${CAPACITY_ROUTE_PREFIX}/home`,
    item: `${CAPACITY_ROUTE_PREFIX}/item/:id`,
    exception: `${CAPACITY_ROUTE_PREFIX}/rule/:ruleId/item/:inventoryId`,
}
